export const baseUrl = "https://tradespad.com"
const baseAppUrl = "https://app.tradespad.com"

export const isLaunched = true

export const waitlistForm = "https://tally.so/r/me0p5J"

export const loginPage = isLaunched ? `${baseAppUrl}/login` : waitlistForm
export const signupPage = isLaunched ? `${baseAppUrl}/register` : waitlistForm
export const getStartedPricingPage = signupPage

export const discordLink = "https://tradespad.com/discord";
export const instagramLink = "https://www.instagram.com/tradespad";